import { render, staticRenderFns } from "./blacklist-form.view.vue?vue&type=template&id=34826c83"
import script from "./blacklist-form.view.vue?vue&type=script&lang=ts"
export * from "./blacklist-form.view.vue?vue&type=script&lang=ts"
import style0 from "./blacklist-form.view.vue?vue&type=style&index=0&id=34826c83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports